import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/services",
    name: "services",
    component: function () {
      return import("../views/ServicesView.vue");
    },
  },
  {
    path: "/about",
    name: "about",
    //import the component
    component: function () {
      return import("../views/AboutView.vue");
    },
  },
  {
    path: "/contact",
    name: "contact",
    // import the component
    component: function () {
      return import("../views/ContactUsView.vue");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
